import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

// Fetch OTP list
export const get_otp_list = createAsyncThunk("otp/list", async (data) => {
  const body = new FormData();
  body.append("action", "list");
  body.append("page", data?.page || 1);
  body.append("limit", data?.limit || 100);
  body.append("search", data?.search || "");

  const response = await fetch(baseUrl + "otp_request.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  return res;
});

const initialState = {
  otp_list: [],
  loading: false,
  total_count: 0,
};

const otpSlice = createSlice({
  name: "otp",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_otp_list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(get_otp_list.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(get_otp_list.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      if (data.success) {
        state.otp_list = data.data || [];
        state.total_count = data.totalcount || 0;
      } else {
        state.otp_list = [];
      }
    });
  },
});

export default otpSlice.reducer;
